.fv{border:1px solid #ddd;}